// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PIssuesCloseOutlinedSvg from "@fishx/icons-svg/es/asn/PIssuesCloseOutlined";
import FishxIcon from '../components/FishxIcon';

var PIssuesCloseOutlined = function PIssuesCloseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PIssuesCloseOutlinedSvg
  }));
};

PIssuesCloseOutlined.displayName = 'PIssuesCloseOutlined';
export default React.forwardRef(PIssuesCloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PIssuesCloseOutlined.js
// module id = 3472
// module chunks = 0